import React from 'react'
import { useSelector } from 'react-redux'
import { Grid } from 'semantic-ui-react'
import { selectCurrencyCodesList, selectIncoTermsList } from '../selectors'
import { InvoiceLine1 } from './invoiceLine1'
import { InvoiceLine2 } from './invoiceLine2'
import { useCurrentShipmentType } from '@hooks/useCurrentShipmentType'


export const InvoiceForm = React.memo(({ procedure, dataSource, updateItem, saveItem,countryList,renderAtLast,invoiceIndex,validateInvoice,translate }) => {

  const currencyList = useSelector(selectCurrencyCodesList)
  const incoTermsList = useSelector(selectIncoTermsList)

  const { version } = useCurrentShipmentType()
  const isDMS = version === 'DMS'
  
  return (
    <Grid className='responsiveGridCss'>
      <Grid.Row>
        <InvoiceLine1
          dataSource={dataSource}
          onBlur={saveItem}
          onChange={updateItem}
          currencyList={currencyList}
          isDMS={isDMS}
        />
        <InvoiceLine2
          dataSource={dataSource}
          onBlur={saveItem}
          onChange={updateItem}
          incoTermsList={incoTermsList}
          countryList={countryList}
          renderAtLast={renderAtLast}
          invoiceIndex={invoiceIndex}
          validateInvoice={validateInvoice}
        />
      </Grid.Row>
      
    </Grid>
  )
})

InvoiceForm.defaultProps = {
  translate: (value) => value,
}
